module.exports = __webpack_public_path__ + "static/media/5-9.6269a47a.mp3";